var serializeForm = function (form) {
	var obj = {};
    console.log('form', document.querySelector(form))
	var formData = new FormData(document.querySelector(form));
    console.log('formData', formData)
	for (var key of formData.keys()) {
		obj[key] = formData.get(key);
	}
    console.log(new URLSearchParams(obj).toString())
    return new URLSearchParams(obj).toString()
};

var theoremCart =  {
    getCart: async function() {

        const response = await fetch(routes.shop_url+'/cart.js', {
            headers: {
                'Content-Type': 'application/json'
            }
        })

        const oldCart = window.cart;
        const cart = await response.json()

        console.log('getCart', cart);

        window.cart = cart;
        const newCart = window.cart;

        document.dispatchEvent(new CustomEvent('cartUpdated', { 
            detail: { oldCart, newCart }
        }));
        return cart

        // EXAMPLE

        // theoremCart.getCart()
        // .then(data)
        // .catch((error) => console.error('Error:', error));
    },
    addItem: async function(productDetails) {
        const response = await fetch(routes.shop_url+'/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(productDetails)
        });
        const json = await response.json();
        return json;

        // EXAMPLE

        // theoremCart.addItem({
        //     'items': [{
        //         'id': variantId,
        //         'quantity': quantity,
        //         'properties': properties
        //     }]
        // })
        // .then(data => {
        //     if(!data.status) {
        //         // SUCCESS
        //         document.querySelectorAll('.j-qb-toggle').forEach(function(draw){ 
        //             draw.parentElement.parentElement.classList.remove('active');
        //         });
        //         document.dispatchEvent(new Event('cartUpdated'));
        //         console.log(data);
        //     } else {
        //         // ERROR
        //         alert(`${data.message}: ${data.description}`);    
        //     }
        // })
    },
    updateItem: async function(variantId, productQuantity) { 
        const items = {};
        items[variantId] = productQuantity;
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({updates: items})
        });
        const json = await response.json();
        return json;
    },
    updateItems: async function(variantDetails) { 
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({updates: variantDetails})
        });
        const json = await response.json();
        return json;

        // EXAMPLE

        // theoremCart.updateItems({
        //          variantId: quantity,
        //          794864053: 2,
        //          794864233: 3
        // })
    },
    addNote: async function(cartNote) { 
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({note: cartNote})
        });
        const json = await response.json();
        return json;
    },
    addAttributes: async function(attributeObj) { 
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: attributeObj
            })
        });
        const json = await response.json();
        return json;
    },
    changeItem: async function(lineItemDetails) {
        const response = await fetch(routes.shop_url+'/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(lineItemDetails)
            
        });
        const json = await response.json();
        return json;
    },
    clearItems: async function() {
        const response = await fetch(routes.shop_url+'/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }); 
        const json = await response.json();
        return json;
    },
    postShippingRates: async function(formSelector) {
        const response = await fetch(routes.shop_url+'/cart/prepare_shipping_rates.json?'+serializeForm(formSelector), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const json = await response.json();
        setTimeout(() => {
            theoremCart.getShippingRates(formSelector)
        }, "1000");
    },
    getShippingRates: async function(formSelector) {
        const response = await fetch(routes.shop_url+'/cart/async_shipping_rates.json?'+serializeForm(formSelector), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const json = await response.json();
        if (response != null) {
            return json;
        } else {
            setTimeout(() => {
                theoremCart.getShippingRates(formSelector)
            }, "1000");
        }
        
    }

};
window.theoremCart = window.theoremCart || theoremCart;



